import { useState } from 'react';
import { toastr } from 'react-redux-toastr';
import { makeApiCall } from '../../../../services/apiService/apiService';

export const useUploadTanNumber = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({});

  const uploadTanNumber = (file, config = {}) => {
    if (!file) {
      toastr.error('Error!', 'Please select a file.');
      return;
    }
    setIsLoading(true);
    const formData = new FormData();
    formData.append('data', file);

    const requestObj = {
      baseUrl: 'zoomApiUrl',
      apiEndPoint: 'uploadBulkTanDoc',
      method: 'POST',
      postFormData: true,
      data: formData,
      contentType: '',
      successCb: res => {
        if (res.status === 'SUCCESS') {
          const response = res.payload;
          config.onSuccess && config.onSuccess(response);
          toastr.success(
            'Upload Successful',
            'File successfully uploaded. Response file will be sent to your registered email address shortly.'
          );
        }
        setIsLoading(false);
      },
      failureCb: err => {
        toastr.error(
          'Something went wrong!',
          err.errorMessage || 'Unable to upload'
        );
        setIsLoading(false);
      },
      catchCb: err => {
        toastr.error(
          'Something went wrong!',
          'Unable to bulk upload consignment appointment.'
        );
        setIsLoading(false);
      }
    };

    return makeApiCall(requestObj);
  };

  return {
    isLoading,
    uploadTanNumber,
    data
  };
};
